/* eslint-disable import/order */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  TablePagination,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  Card,
  CardMedia,
  Avatar,
  Box,
  InputAdornment,
  CardContent,
  CardActionArea,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ImageIcon from '@mui/icons-material/Image';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import GridViewIcon from '@mui/icons-material/GridView';
import TableViewIcon from '@mui/icons-material/TableView';

const ProductCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
}));

const ProductImageWrapper = styled('div')({
  width: '100%',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fff',
  padding: '8px',
  overflow: 'hidden',
});

const ProductInfo = styled('div')({
  padding: '12px',
  flexGrow: 1,
});

const ProductInitialValue = {
  Category_Id: null,
  Product_Details_Description: '',
  Product_Details_Code: '',
  Rate: '',
  UOM: '',
  Image: null,
  Active: 'Y',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const Products = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [productsTableData, setProductsTableData] = useState([]);
  const [products, setProducts] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [uomList, setUomList] = useState(['KG', 'LTR', 'PCS', 'BOX', 'BAG', 'METER']);
  const [UserId, setUserId] = useState(null);
  const [initialValue, setInitialValue] = useState(ProductInitialValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'table'

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    GetAllProducts();
    GetAllSubCategories();
  }, []);

  const GetAllSubCategories = async () => {
    try {
      showLoading();
      const response = await axios.get('Master/SubCategory/GetAllSubCategory');
      setSubCategories(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const productValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        Category_Id: Yup.object().required('Please select Sub Category'),
        Product_Details_Description: Yup.string()
          .trim()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Product Name')
          .test('unique-product', 'This product already exists under this category', function (value) {
            const { Category_Id } = this.parent;
            if (!Category_Id || !value) return true;

            if (
              edit &&
              initialValue.Category_Id?.Category_Id === Category_Id.Category_Id &&
              initialValue.Product_Details_Description?.toLowerCase() === value?.toLowerCase()
            ) {
              return true;
            }

            return !products.some(
              (item) =>
                item.Category_Id === Category_Id.Category_Id &&
                item.Product_Details_Description?.toLowerCase() === value?.toLowerCase() &&
                item.Product_Details_Id !== initialValue.Product_Details_Id
            );
          }),
        Product_Details_Code: Yup.string().trim().nullable(),
        Rate: Yup.string().trim().nullable(),
        UOM: Yup.string().trim().required('UOM is required').max(20, 'UOM cannot exceed 20 characters'),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [products, initialValue, edit]
  );

  async function GetAllProducts() {
    try {
      showLoading();
      const response = await axios.get('Master/Products/GetAllProducts');
      setProducts(response.data);
      setProductsTableData(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleImageChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFieldValue('Image', file);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (setFieldValue) => {
    setImagePreview(null);
    setFieldValue('Image', null);
  };

  async function InsertProduct(values) {
    try {
      const { Category_Id, Image, ...remainingValues } = values;
      const formData = new FormData();

      formData.append('Product_Details_Description', remainingValues.Product_Details_Description);
      formData.append('Product_Details_Code', remainingValues.Product_Details_Code || '');
      formData.append('Category_Id', Category_Id.Category_Id);
      formData.append('Rate', remainingValues.Rate || '');
      formData.append('UOM', remainingValues.UOM || '');
      formData.append('Created_By', UserId);
      formData.append('Active', remainingValues.Active);
      if (Image) {
        formData.append('Image', Image);
      }

      showLoading();
      await axios.post('Master/Products/InsertProducts', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      handleSubmitSuccess();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const UpdateProduct = async (values) => {
    try {
      const { Category_Id, Image, ...remainingValues } = values;
      const formData = new FormData();

      formData.append('Product_Details_Id', remainingValues.Product_Details_Id);
      formData.append('Product_Details_Description', remainingValues.Product_Details_Description);
      formData.append('Product_Details_Code', remainingValues.Product_Details_Code || '');
      formData.append('Category_Id', Category_Id.Category_Id);
      formData.append('Rate', remainingValues.Rate || '');
      formData.append('UOM', remainingValues.UOM || '');
      formData.append('Modify_By', UserId);
      formData.append('Active', remainingValues.Active);

      if (Image instanceof File) {
        formData.append('Image', Image);
      } else if (Image && typeof Image === 'string') {
        formData.append('Image', Image);
      }

      showLoading();
      await axios.post('Master/Products/UpdateProducts', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      handleSubmitSuccess();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const handleSubmitSuccess = () => {
    GetAllProducts();
    handleCloseDialog();
    openSnackBar(`Product ${edit ? 'Updated' : 'Added'} Successfully!`, edit ? 'warning' : 'success');
  };

  const DeleteProduct = async () => {
    try {
      showLoading();
      await axios.delete(`Master/Products/DeleteProducts/${deleteId}`);
      GetAllProducts();
      openSnackBar('Product Deleted Successfully!', 'warning');
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const subCategory = subCategories.find((cat) => cat.Category_Id === values.Category_Id);
    setInitialValue({
      ...values,
      Category_Id: subCategory || null,
      Image: values.Image || null,
    });
    if (values.Image) {
      setImagePreview(`${axios.defaults.products}/${values.Image}`);
    }
    setEdit(true);
    setOpen(true);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  useEffect(() => {
    const newTableData = products.filter(
      (product) =>
        `${product.Product_Details_Description} ${product.Category_Description} ${product.Product_Details_Code} ${product.Rate} ${product.UOM}`
          .toLowerCase()
          .includes(filterData.searchTerm?.toLowerCase()) && product.Active === (filterData.Active ? 'Y' : 'N')
    );
    if (page > 0) setPage(0);
    setProductsTableData(newTableData);
  }, [products, filterData]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEdit(false);
    setInitialValue(ProductInitialValue);
    setImagePreview(null);
  };

  const handleImagePreview = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = productsTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [productsTableData, page, rowsPerPage]);

  const toggleViewMode = () => {
    setViewMode(viewMode === 'grid' ? 'table' : 'grid');
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* Header Section */}
        <Paper elevation={3} sx={{ p: 1, mb: 3, backgroundColor: '#2A4759', color: 'white' }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                Products
              </Typography>
            </Grid>
            <Grid item>
              <Stack direction="row" spacing={2} alignItems="center">
                <Button
                  variant="contained"
                  color="success"
                  onClick={toggleViewMode}
                  startIcon={viewMode === 'grid' ? <TableViewIcon /> : <GridViewIcon />}
                  sx={{ boxShadow: 3 }}
                  size="small"
                >
                  {viewMode === 'grid' ? 'Table View' : 'Grid View'}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpen(true)}
                  startIcon={<PlaylistAddIcon />}
                  sx={{ boxShadow: 3 }}
                >
                  Add Product
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        {/* Filter Section */}
        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                color="secondary"
                label="Search Products"
                size="small"
                onChange={(e) => handleFilterDataChange('searchTerm', e.target.value)}
                value={filterData.searchTerm}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
                <Typography variant="subtitle2" fontWeight="bold">
                  Show Active:
                </Typography>
                <Switch
                  size="small"
                  checked={filterData.Active}
                  onChange={(e) => handleFilterDataChange('Active', e.target.checked)}
                  color="success"
                />
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        {viewMode === 'grid' ? (
          /* Products Grid View */
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {(rowsPerPage > 0
              ? productsTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : productsTableData
            ).map((product, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={product.Product_Details_Id}>
                <ProductCard elevation={4}>
                  <CardActionArea onClick={() => handleImagePreview(`${axios.defaults.products}/${product.Image}`)}>
                    <ProductImageWrapper>
                      {product.Image ? (
                        <img
                          src={`${axios.defaults.products}/${product.Image}`}
                          alt={product.Product_Details_Description}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      ) : (
                        <Avatar sx={{ width: 80, height: 80, bgcolor: 'grey.300' }}>
                          <ImageIcon fontSize="large" color="disabled" />
                        </Avatar>
                      )}
                    </ProductImageWrapper>
                  </CardActionArea>
                  <ProductInfo>
                    <Typography variant="h6" gutterBottom>
                      {product.Product_Details_Description}
                    </Typography>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Chip
                        label={product.Category_Description}
                        color="primary"
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 'bold' }}
                      />
                      <Chip
                        label={product.Active === 'Y' ? 'Active' : 'Inactive'}
                        color={product.Active === 'Y' ? 'success' : 'error'}
                        size="small"
                        variant="outlined"
                        icon={product.Active === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                      />
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        Code: {product.Product_Details_Code || 'N/A'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        UOM: {product.UOM}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="subtitle2" color="primary">
                        {product.Rate ? `₹${product.Rate}` : '₹ ---'}
                      </Typography>
                      <Box>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(product);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(product.Product_Details_Id);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteForeverIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </ProductInfo>
                </ProductCard>
              </Grid>
            ))}
          </Grid>
        ) : (
          /* Products Table View */
          <TableContainer component={Paper} elevation={3} sx={{ mb: 3, maxHeight: '400px' }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell>Image</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>UOM</TableCell>
                  <TableCell>Rate</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? productsTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : productsTableData
                ).map((product) => (
                  <TableRow key={product.Product_Details_Id} hover>
                    <TableCell>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleImagePreview(`${axios.defaults.products}/${product.Image}`)}
                      >
                        {product.Image ? (
                          <img
                            src={`${axios.defaults.products}/${product.Image}`}
                            alt={product.Product_Details_Description}
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              objectFit: 'contain',
                            }}
                          />
                        ) : (
                          <Avatar sx={{ width: 40, height: 40, bgcolor: 'grey.300' }}>
                            <ImageIcon fontSize="small" color="disabled" />
                          </Avatar>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>{product.Product_Details_Description}</TableCell>
                    <TableCell>{product.Category_Description}</TableCell>
                    <TableCell>{product.Product_Details_Code || 'N/A'}</TableCell>
                    <TableCell>{product.UOM}</TableCell>
                    <TableCell>{product.Rate ? `₹${product.Rate}` : '---'}</TableCell>
                    <TableCell>
                      <Chip
                        label={product.Active === 'Y' ? 'Active' : 'Inactive'}
                        color={product.Active === 'Y' ? 'success' : 'error'}
                        size="small"
                        variant="outlined"
                        icon={
                          product.Active === 'Y' ? (
                            <CheckCircleOutlineIcon fontSize="small" />
                          ) : (
                            <HighlightOffIcon fontSize="small" />
                          )
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton size="small" color="primary" onClick={() => handleEditClick(product)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setDeleteId(product.Product_Details_Id);
                          setOpenDelete(true);
                        }}
                      >
                        <DeleteForeverIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Pagination */}
        <Box display="flex" justifyContent="center" mt={3}>
          <TablePagination
            rowsPerPageOptions={[12, 24, 36, { label: 'All', value: -1 }]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        </Box>

        {/* Add/Edit Product Dialog */}
        <Dialog maxWidth={'md'} open={open} onClose={handleCloseDialog} fullWidth>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h5" fontWeight="bold" color="primary">
                {edit ? 'Edit Product' : 'Add New Product'}
              </Typography>
              <IconButton onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ mb: 3 }} />
            <Formik
              validationSchema={productValidationSchema}
              initialValues={initialValue}
              onSubmit={async (values, { resetForm }) => {
                if (edit) await UpdateProduct(values);
                else await InsertProduct(values);
                resetForm();
              }}
              enableReinitialize
            >
              {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                <Form>
                  <Grid container spacing={3}>
                    {/* Left Column - Image Upload */}
                    <Grid item xs={12} md={3}>
                      <Box
                        sx={{
                          border: '1px dashed grey',
                          borderRadius: 2,
                          p: 2,
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {imagePreview ? (
                          <>
                            <Box
                              sx={{
                                width: '100%',
                                height: '200px',
                                mb: 2,
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <img
                                src={imagePreview}
                                alt="Preview"
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  objectFit: 'contain',
                                }}
                              />
                            </Box>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              fullWidth
                              onClick={() => removeImage(setFieldValue)}
                            >
                              Remove Image
                            </Button>
                          </>
                        ) : (
                          <>
                            <Avatar sx={{ width: 80, height: 80, bgcolor: 'grey.200', mb: 2 }}>
                              <ImageIcon fontSize="large" color="disabled" />
                            </Avatar>
                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<ImageIcon />}
                              size="small"
                              fullWidth
                            >
                              Upload Image
                              <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => handleImageChange(e, setFieldValue)}
                              />
                            </Button>
                          </>
                        )}
                      </Box>
                    </Grid>

                    {/* Right Column - Form Fields */}
                    <Grid item xs={12} md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Product Name"
                            name="Product_Details_Description"
                            onBlur={handleBlur}
                            required
                            error={touched.Product_Details_Description && !!errors.Product_Details_Description}
                            helperText={touched.Product_Details_Description && errors.Product_Details_Description}
                            value={values.Product_Details_Description}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <Autocomplete
                            options={subCategories}
                            size="small"
                            getOptionLabel={(option) => option.Category_Description}
                            isOptionEqualToValue={(option, value) => option.Category_Id === value?.Category_Id}
                            value={values.Category_Id}
                            onChange={(event, newValue) => {
                              setFieldValue('Category_Id', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Product Category"
                                required
                                fullWidth
                                error={touched.Category_Id && !!errors.Category_Id}
                                helperText={touched.Category_Id && errors.Category_Id}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            size="small"
                            label="UOM"
                            name="UOM"
                            required
                            onBlur={handleBlur}
                            error={touched.UOM && !!errors.UOM}
                            helperText={touched.UOM && errors.UOM}
                            value={values.UOM}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Product Code (Optional)"
                            name="Product_Details_Code"
                            onBlur={handleBlur}
                            error={touched.Product_Details_Code && !!errors.Product_Details_Code}
                            helperText={touched.Product_Details_Code && errors.Product_Details_Code}
                            value={values.Product_Details_Code}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Rate (Optional)"
                            name="Rate"
                            onBlur={handleBlur}
                            error={touched.Rate && !!errors.Rate}
                            helperText={touched.Rate && errors.Rate}
                            value={values.Rate}
                            onChange={handleChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <CurrencyRupeeIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl component="fieldset" fullWidth>
                            <FormLabel component="legend">Active</FormLabel>
                            <RadioGroup row value={values.Active} name="Active" onChange={handleChange}>
                              <FormControlLabel
                                value="Y"
                                control={<Radio color="primary" size="small" />}
                                label="Yes"
                              />
                              <FormControlLabel value="N" control={<Radio color="error" size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography variant="caption" color="error">
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={handleCloseDialog}
                              disabled={isSubmitting}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              color={edit ? 'warning' : 'primary'}
                              onClick={submitForm}
                              disabled={isSubmitting}
                            >
                              {edit ? 'Update Product' : 'Add Product'}
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Paper>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} maxWidth="xs" fullWidth>
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Confirm Delete
            </Typography>
          </DialogTitle>
          <Box p={3}>
            <Typography>Are you sure you want to delete this product? This action cannot be undone.</Typography>
          </Box>
          <DialogActions sx={{ p: 2 }}>
            <Button variant="outlined" onClick={handleCloseDelete}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={DeleteProduct} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Image Preview Dialog */}
        <Dialog open={openImageDialog} onClose={handleCloseImageDialog} maxWidth="md" fullWidth>
          <DialogTitle>Product Image</DialogTitle>
          <Box p={2} display="flex" justifyContent="center">
            <Card sx={{ maxWidth: '100%' }}>
              <CardMedia
                component="img"
                image={selectedImage}
                alt="Product Image"
                sx={{ maxHeight: '70vh', objectFit: 'contain' }}
              />
            </Card>
          </Box>
          <DialogActions>
            <Button onClick={handleCloseImageDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default Products;
